import { render, staticRenderFns } from "./notification-IssueClosed.vue?vue&type=template&id=64355c2c&scoped=true"
import script from "./notification-IssueClosed.vue?vue&type=script&lang=js"
export * from "./notification-IssueClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64355c2c",
  null
  
)

export default component.exports